import { TextField, styled } from "@mui/material";
import PhoneInput from "react-phone-input-2";
// import { DatePicker } from "@mui/x-date-pickers";

export const StyledInput = styled(TextField)({
  "& .MuiInputLabel-root:not(.MuiInputLabel-shrink)": {
    transform: "translate(14px, 8px) scale(1)",
    color: "#bdbdbd",
  },
  "& .MuiInputBase-input": {
    padding: 8,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderRadius: 8,
    },
  },
});

// export const StyledDatePicker = styled(DatePicker)({
//   "& .MuiInputLabel-root:not(.Mui-focused)": {
//     color: "#bdbdbd",
//   },
//   "& .MuiInputBase-input": {
//     padding: 8,
//   },
//   "& .MuiOutlinedInput-root": {
//     "& fieldset": {
//       borderRadius: 8,
//     },
//   },
// });

export const StyledPhoneInput = styled(PhoneInput)({
  width: "100%",
  height: "39px",
  "& .form-control": {
    width: "100%",
    borderRadius: 8,
    height: "39px",
  },

  "& .flag-dropdown": {
    borderRadius: "8px 0 0 8px !important",
    "& .selected-flag": {
      borderRadius: "8px 0 0 8px !important",
    },
  },
});
